"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Banda App API
 * The API for the Banda App
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserInvitationControllerApi = exports.UserInvitationControllerApiFactory = exports.UserInvitationControllerApiFp = exports.UserInvitationControllerApiAxiosParamCreator = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * UserInvitationControllerApi - axios parameter creator
 * @export
 */
const UserInvitationControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {number} [pageSize]
         * @param {number} [pageNumber]
         * @param {string} [sortBy]
         * @param {string} [sortOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInvitationsGet: (searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/usersInvitations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (searchField !== undefined) {
                localVarQueryParameter['searchField'] = searchField;
            }
            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInvitationsIdDelete: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiUsersInvitationsIdDelete', 'id', id);
            const localVarPath = `/api/usersInvitations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInvitationsIdEmailPost: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiUsersInvitationsIdEmailPost', 'id', id);
            const localVarPath = `/api/usersInvitations/{id}/email`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInvitationsIdGet: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiUsersInvitationsIdGet', 'id', id);
            const localVarPath = `/api/usersInvitations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {UserInvitation} userInvitation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInvitationsPost: (userInvitation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userInvitation' is not null or undefined
            (0, common_1.assertParamExists)('apiUsersInvitationsPost', 'userInvitation', userInvitation);
            const localVarPath = `/api/usersInvitations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userInvitation, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInvitationsTokenAcceptGet: (token, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'token' is not null or undefined
            (0, common_1.assertParamExists)('apiUsersInvitationsTokenAcceptGet', 'token', token);
            const localVarPath = `/api/usersInvitations/{token}/accept`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInvitationsTokenRejectGet: (token, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'token' is not null or undefined
            (0, common_1.assertParamExists)('apiUsersInvitationsTokenRejectGet', 'token', token);
            const localVarPath = `/api/usersInvitations/{token}/reject`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.UserInvitationControllerApiAxiosParamCreator = UserInvitationControllerApiAxiosParamCreator;
/**
 * UserInvitationControllerApi - functional programming interface
 * @export
 */
const UserInvitationControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.UserInvitationControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {number} [pageSize]
         * @param {number} [pageNumber]
         * @param {string} [sortBy]
         * @param {string} [sortOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInvitationsGet(searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiUsersInvitationsGet(searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInvitationsIdDelete(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiUsersInvitationsIdDelete(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInvitationsIdEmailPost(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiUsersInvitationsIdEmailPost(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInvitationsIdGet(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiUsersInvitationsIdGet(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {UserInvitation} userInvitation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInvitationsPost(userInvitation, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiUsersInvitationsPost(userInvitation, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInvitationsTokenAcceptGet(token, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiUsersInvitationsTokenAcceptGet(token, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInvitationsTokenRejectGet(token, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiUsersInvitationsTokenRejectGet(token, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.UserInvitationControllerApiFp = UserInvitationControllerApiFp;
/**
 * UserInvitationControllerApi - factory interface
 * @export
 */
const UserInvitationControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.UserInvitationControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {number} [pageSize]
         * @param {number} [pageNumber]
         * @param {string} [sortBy]
         * @param {string} [sortOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInvitationsGet(searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, options) {
            return localVarFp.apiUsersInvitationsGet(searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInvitationsIdDelete(id, options) {
            return localVarFp.apiUsersInvitationsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInvitationsIdEmailPost(id, options) {
            return localVarFp.apiUsersInvitationsIdEmailPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInvitationsIdGet(id, options) {
            return localVarFp.apiUsersInvitationsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserInvitation} userInvitation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInvitationsPost(userInvitation, options) {
            return localVarFp.apiUsersInvitationsPost(userInvitation, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInvitationsTokenAcceptGet(token, options) {
            return localVarFp.apiUsersInvitationsTokenAcceptGet(token, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInvitationsTokenRejectGet(token, options) {
            return localVarFp.apiUsersInvitationsTokenRejectGet(token, options).then((request) => request(axios, basePath));
        },
    };
};
exports.UserInvitationControllerApiFactory = UserInvitationControllerApiFactory;
/**
 * UserInvitationControllerApi - object-oriented interface
 * @export
 * @class UserInvitationControllerApi
 * @extends {BaseAPI}
 */
class UserInvitationControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [searchField]
     * @param {string} [searchString]
     * @param {number} [pageSize]
     * @param {number} [pageNumber]
     * @param {string} [sortBy]
     * @param {string} [sortOrder]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserInvitationControllerApi
     */
    apiUsersInvitationsGet(searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, options) {
        return (0, exports.UserInvitationControllerApiFp)(this.configuration).apiUsersInvitationsGet(searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserInvitationControllerApi
     */
    apiUsersInvitationsIdDelete(id, options) {
        return (0, exports.UserInvitationControllerApiFp)(this.configuration).apiUsersInvitationsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserInvitationControllerApi
     */
    apiUsersInvitationsIdEmailPost(id, options) {
        return (0, exports.UserInvitationControllerApiFp)(this.configuration).apiUsersInvitationsIdEmailPost(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserInvitationControllerApi
     */
    apiUsersInvitationsIdGet(id, options) {
        return (0, exports.UserInvitationControllerApiFp)(this.configuration).apiUsersInvitationsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserInvitation} userInvitation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserInvitationControllerApi
     */
    apiUsersInvitationsPost(userInvitation, options) {
        return (0, exports.UserInvitationControllerApiFp)(this.configuration).apiUsersInvitationsPost(userInvitation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserInvitationControllerApi
     */
    apiUsersInvitationsTokenAcceptGet(token, options) {
        return (0, exports.UserInvitationControllerApiFp)(this.configuration).apiUsersInvitationsTokenAcceptGet(token, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserInvitationControllerApi
     */
    apiUsersInvitationsTokenRejectGet(token, options) {
        return (0, exports.UserInvitationControllerApiFp)(this.configuration).apiUsersInvitationsTokenRejectGet(token, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.UserInvitationControllerApi = UserInvitationControllerApi;
